/** @jsxImportSource react */
import React from 'react';
import { useAuth } from '../contexts/auth';
import { useTranslation } from '../i18n';
import { Lock, LogOut } from 'lucide-react';
import { Button } from '../components/ui/Button';

const LockedAccountPage: React.FC = () => {
    const { logout } = useAuth();
    const { t } = useTranslation();

    return (
        <div className="relative min-h-screen w-full bg-secondary-50 flex items-center justify-center p-4 overflow-hidden">
            <div className="absolute -top-24 -left-24 w-96 h-96 bg-primary-500/10 rounded-full mix-blend-multiply filter blur-3xl opacity-50"></div>
            <div className="absolute -bottom-24 -right-24 w-96 h-96 bg-secondary-500/10 rounded-full mix-blend-multiply filter blur-3xl opacity-50"></div>
            
            <div className="relative z-10 w-full max-w-lg mx-auto bg-white p-8 sm:p-12 shadow-2xl rounded-xl border border-secondary-100 text-center animate-fade-in">
                <div className="flex justify-center mb-6">
                    <div className="h-20 w-20 bg-secondary-100 rounded-full flex items-center justify-center text-secondary-500">
                        <Lock size={40} />
                    </div>
                </div>
                <h1 className="text-3xl font-bold text-secondary-900 mb-4">{t('accountLockedTitle')}</h1>
                <p className="text-secondary-600 mb-8 max-w-sm mx-auto">
                    {t('accountLockedMessage')}
                </p>
                <Button onClick={logout} size="lg" variant="outline" className="w-full sm:w-auto">
                    <LogOut className="w-4 h-4 me-2" />
                    {t('logout')}
                </Button>
            </div>
        </div>
    );
};

export default LockedAccountPage;
